import { getDataStreamType } from 'dashboard-engine/util/getDataStreamType';
import { useAvailableDataStreamDefinitionsForWorkspace } from 'queries/hooks/useAvailableDataStreamDefinitionsForWorkspace';
import { EditorSteps } from '../constants';
import { useTileEditorStepsContext } from '../contexts/TileEditorStepsContext';
import { TileEditorDataStream } from '../state/TileEditorState';
import { useTileEditorStore } from '../state/TileEditorStoreProvider';
import { TileEditorDataStreams } from '../state/useTileEditorDataStreams';

export const useSplashScreenDataStreamSelect = (
    dataSourceId: string,
    dataStreams: NonNullable<ReturnType<typeof useAvailableDataStreamDefinitionsForWorkspace>['data']>,
    tileEditorDataStreams: TileEditorDataStreams
) => {
    const { setCurrentEditorStep } = useTileEditorStepsContext();
    const { dispatch } = useTileEditorStore((s) => ({ dispatch: s.dispatch }));

    let dataStreamInstance: TileEditorDataStream | undefined;

    const datastreamsForDataSource = dataStreams.filter(({ pluginId }) => pluginId === dataSourceId);

    if (datastreamsForDataSource.length === 1) {
        dataStreamInstance = tileEditorDataStreams.dataStreamsById.get(datastreamsForDataSource[0].id);
    }

    return {
        selectDatasource: () => {
            if (dataStreamInstance) {
                const {
                    supportsScope,
                    isConfigurable
                } = getDataStreamType(dataStreamInstance);
                    
                if (supportsScope) {
                    dispatch({ 
                        type: 'dataStream.selectDataStream', 
                        dataStream: dataStreamInstance,
                        forceStep: EditorSteps.objects
                    });
                    return setCurrentEditorStep(EditorSteps.objects, true);
                }
            
                if (isConfigurable) {
                    dispatch({ 
                        type: 'dataStream.selectDataStream', 
                        dataStream: dataStreamInstance,
                        forceStep: EditorSteps.parameters
                    });
                    return setCurrentEditorStep(EditorSteps.parameters, true);
                }
            
                dispatch({ 
                    type: 'dataStream.selectDataStream', 
                    dataStream: dataStreamInstance,
                    forceStep: EditorSteps.timeframe
                });
                return setCurrentEditorStep(EditorSteps.timeframe, true);
            }
        
            dispatch({ type: 'dataStream.updateFilters', filters: { dataSourceId } });
            setCurrentEditorStep(EditorSteps.dataStream);
        }
    };
};
